/* eslint-disable no-console */
import Vue from 'vue'

const state = {
    isLoading: false,
    requirement: null
}

const getters = {
  
}

const actions = {
    get (store, { tenantId, contactIdHash, certRequirementId }) {
        store.commit('GET_PENDING')
        return new Promise((resolve, reject) => {
          Vue.axios.get(`/api/1.0/CertificationRequirements/${tenantId}/${contactIdHash}/${certRequirementId}`)
            .then(response => {
              store.commit('GET_SUCCESS', response.data)
              resolve(response);
            })
            .catch(error => {
              store.commit('GET_FAILURE', error);
              reject(error);
            })
        })
      },
}

const mutations = {
    GET_PENDING (state) {
        state.isLoading = true
      },
    GET_SUCCESS (state, data) {
        state.isLoading = false
        state.requirement = data
    },
    GET_FAILURE (state, error) {
        state.isLoading = false
        console.log(error)
    },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
